<template>
	<div>
		<b-card>
			<template #header>
				<b-row>
					<b-col>
						<b-button @click="$router.back()" variant="outline-dark" class="mr-3"><i class="fa fa-arrow-left mr-2"/>{{ $t('back') }}</b-button>
					</b-col>
					<b-col align="center">
						<h4><b>Остатка</b></h4>
					</b-col>
					<b-col align="right">
						<h4 class="d-inline-block"><b>{{ $t('department.title') }}:</b> {{ depName }}</h4>
						<b-button @click="getList(null)" variant="dark" class="d-inline-block ml-4">Все</b-button>
						<b-button v-b-toggle.collapse-1 variant="dark" class="d-inline-block ml-3"><i class="fa fa-filter"/></b-button>
					</b-col>
				</b-row>
			</template>
			<template #default>
				<b-overlay :show="loading">
					<b-collapse id="collapse-1">
						<b-row class="mb-2">
							<b-col>
								<b-form-input v-model="name" :placeholder="$t('name')"/>
							</b-col>
							<b-col>
								<b-form-input v-model="barcode" :placeholder="$t('goods.special-barcode')"/>
							</b-col>
							<b-col>
								<b-form-input v-model="multiBarcode" :placeholder="$t('goods.barcode')"/>
							</b-col>
							<b-col cols="1">
								<b-button @click="getList(multiBarcode)" variant="primary" class="fa fa-search"/>
							</b-col>
						</b-row>
					</b-collapse>
					<table class="table table-striped table-bordered">
						<thead>
							<tr>
								<th class="text-center" style="width: 8px">№</th>
								<th class="text-center" style="width: 15%">{{ $t('goods.special-barcode') }}</th>
								<th class="text-center" style="width: 40%">{{ $t('name') }}</th>
								<th class="text-center" style="width: 29%">{{ $t('goods.barcode') }}</th>
								<th class="text-center" style="width: 8%">{{ $t('incomes.create.price') }}</th>
								<th class="text-center" style="width: 8%">{{ $t('Oстатка') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in list" :key="`item-${index}`">
								<td class="text-center">{{ index+1 }}</td>
								<td class="text-center">{{ item.barcode }}</td>
								<td>{{ item.name }}</td>
								<td class="text-center">{{ item.barcodeString }}</td>
								<td class="text-center">€ {{ item.priceUzs }}</td>
								<td class="text-center">{{ item.deps[`${depName}`].inventory }}</td>
							</tr>
						</tbody>
					</table>
				</b-overlay>
			</template>
		</b-card>
	</div>
</template>

<script>
import {BOverlay} from "bootstrapVue2";
import ApiService from "../../../services/api.service";
import { convertRuToEn } from "@/utils/helper";

export default {
	name: "warehouseForPos",
	components: {BOverlay},
	data() {
		return {
			list: [],
			loading: false,
			name: '',
			barcode: '',
			multiBarcode: ''
		}
	},
	computed: {
		depName() {
			return localStorage.getItem('dep_name')
		},
		depId() {
			return localStorage.getItem('dep_id')
		}
	},
	methods: {
		barcodeScanned(barcodeNum) {
				let barcodeNumber  = convertRuToEn(barcodeNum)
			this.multiBarcode = barcodeNumber
			this.getList(barcodeNumber);
		},
		async getList(multiBarcode) {
			this.loading = true
			let param = '&catId=14'
			if (multiBarcode&&multiBarcode!=='')
				param = `&multiBarcode=${multiBarcode}`
			else
				this.multiBarcode = ''
			if (this.name&&this.name!=='')
				param+=`&name${this.name}`
			if (this.barcode&&this.barcode!=='')
				param+=`&barcode${this.barcode}`
			await ApiService.get(`/item-balance/list?depIds=${this.depId}${param}`).then(res => {
				this.list = res.data['MAGAZIN']
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		}
	},
	created() {
		this.$barcodeScanner.init(this.barcodeScanned);
	}
}
</script>

<style scoped>

</style>
